import { compareEvents } from '../utils/EventOrdering';
export class StandardsComparator {
    constructor(timeConverter) {
        this.timeConverter = timeConverter;
    }
    compareWithStandards(swimmerData, standards) {
        const eventTimesMap = this.groupTimesByEvent(swimmerData.times);
        const comparisons = this.generateComparisons(eventTimesMap, standards);
        return {
            swimmerName: swimmerData.name,
            tiref: swimmerData.tiref,
            comparisons
        };
    }
    groupTimesByEvent(times) {
        const evntTimesMap = new Map();
        times.forEach(swimTime => {
            const event = swimTime.event;
            if (!evntTimesMap.has(event)) {
                evntTimesMap.set(event, {});
            }
            const eventTimes = evntTimesMap.get(event);
            if (swimTime.course === '50m') {
                eventTimes.lc = swimTime;
            }
            else if (swimTime.course === '25m') {
                eventTimes.sc = swimTime;
            }
        });
        return evntTimesMap;
    }
    generateComparisons(eventTimesMap, standards) {
        const comparisons = [];
        const sortedEvents = Array.from(eventTimesMap.keys()).sort(compareEvents);
        sortedEvents.forEach(event => {
            const eventTimes = eventTimesMap.get(event);
            const lcKey = `${event}_50m`;
            if (standards[lcKey]) {
                const lcTimes = this.collectLCPossibleTimes(eventTimes);
                const comparison = lcTimes.length > 0
                    ? this.createComparison(event, this.findFastestTime(lcTimes), standards[lcKey], '50m')
                    : this.createUnavailableComparison(event, eventTimes, standards[lcKey], '50m');
                if (comparison)
                    comparisons.push(comparison);
            }
            const scKey = `${event}_25m`;
            if (standards[scKey]) {
                const scTimes = this.collectSCPossibleTimes(eventTimes);
                const comparison = scTimes.length > 0
                    ? this.createComparison(event, this.findFastestTime(scTimes), standards[scKey], '25m')
                    : this.createUnavailableComparison(event, eventTimes, standards[scKey], '25m');
                if (comparison)
                    comparisons.push(comparison);
            }
        });
        return comparisons;
    }
    collectLCPossibleTimes(eventTimes) {
        const possibleTimes = [];
        if (eventTimes.lc) {
            possibleTimes.push({
                time: eventTimes.lc.time,
                label: '50m',
                date: eventTimes.lc.date,
                venue: eventTimes.lc.venue
            });
        }
        if (eventTimes.sc && eventTimes.sc.convertedToLC) {
            possibleTimes.push({
                time: eventTimes.sc.convertedToLC,
                label: '25→50m',
                date: eventTimes.sc.date,
                venue: eventTimes.sc.venue
            });
        }
        return possibleTimes;
    }
    collectSCPossibleTimes(eventTimes) {
        const possibleTimes = [];
        if (eventTimes.sc) {
            possibleTimes.push({
                time: eventTimes.sc.time,
                label: '25m',
                date: eventTimes.sc.date,
                venue: eventTimes.sc.venue
            });
        }
        if (eventTimes.lc && eventTimes.lc.convertedToSC) {
            possibleTimes.push({
                time: eventTimes.lc.convertedToSC,
                label: '50→25m',
                date: eventTimes.lc.date,
                venue: eventTimes.lc.venue
            });
        }
        return possibleTimes;
    }
    findFastestTime(possibleTimes) {
        let fastestOption = possibleTimes[0];
        let fastestSeconds = this.timeConverter.parseTimeToSeconds(fastestOption.time);
        for (let i = 1; i < possibleTimes.length; i++) {
            const currentSeconds = this.timeConverter.parseTimeToSeconds(possibleTimes[i].time);
            if (currentSeconds < fastestSeconds) {
                fastestOption = possibleTimes[i];
                fastestSeconds = currentSeconds;
            }
        }
        return fastestOption;
    }
    createUnavailableComparison(event, eventTimes, countyEntry, standardCourse) {
        const swimTime = standardCourse === '50m'
            ? (eventTimes.lc || eventTimes.sc)
            : (eventTimes.sc || eventTimes.lc);
        if (!swimTime)
            return null;
        return {
            event,
            course: swimTime.course,
            standardCourse,
            swimmerTime: `${swimTime.time} (${swimTime.course}, no conversion)`,
            standardTime: countyEntry.time,
            considerationTime: countyEntry.considerationTime,
            meetsConsideration: undefined,
            difference: 'N/A',
            isFaster: null,
            percentDiff: 'N/A',
            ageCategory: countyEntry.ageCategory,
            date: swimTime.date,
            venue: swimTime.venue,
        };
    }
    createComparison(event, fastestOption, countyEntry, standardCourse) {
        const fastestSeconds = this.timeConverter.parseTimeToSeconds(fastestOption.time);
        const standardSeconds = this.timeConverter.parseTimeToSeconds(countyEntry.time);
        const difference = fastestSeconds - standardSeconds;
        const percentDiff = ((difference / standardSeconds) * 100).toFixed(2);
        const meetsConsideration = countyEntry.considerationTime != null
            ? fastestSeconds <= this.timeConverter.parseTimeToSeconds(countyEntry.considerationTime)
            : undefined;
        return {
            event,
            course: fastestOption.label,
            standardCourse,
            swimmerTime: fastestOption.time,
            standardTime: countyEntry.time,
            considerationTime: countyEntry.considerationTime,
            meetsConsideration,
            difference: this.timeConverter.formatSecondsToTime(Math.abs(difference)),
            isFaster: difference <= 0,
            percentDiff,
            ageCategory: countyEntry.ageCategory,
            date: fastestOption.date,
            venue: fastestOption.venue,
        };
    }
}
